var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKickOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "be532f1b-a723-4792-9acb-ee503d2372e2",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ee678d8a-09eb-482b-888f-96f7cadb505e",
    d: "M63.67,43.17V54a4.17,4.17,0,0,1-8.34,0V43.17h-13A34.67,34.67,0,1,0,77,77.89c0-.66.87-16.06,23.83-16.06h19.5V43.17Zm53.66,15.66h-16.5C75,58.83,74,77.59,74,77.83A31.67,31.67,0,1,1,42.33,46.17h10V54a7.17,7.17,0,0,0,14.34,0V46.17h50.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee678d8a-09eb-482b-888f-96f7cadb505e",
    x: 58.17,
    y: 9.88,
    width: 3,
    height: 22.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee678d8a-09eb-482b-888f-96f7cadb505e",
    x: 44.15,
    y: 13.95,
    width: 3,
    height: 22.62,
    transform: "translate(-6.46 22.66) rotate(-26.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee678d8a-09eb-482b-888f-96f7cadb505e",
    x: 62.33,
    y: 23.76,
    width: 22.62,
    height: 3,
    transform: "translate(18.57 80.28) rotate(-63.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickOff);
export default __webpack_public_path__ + "static/media/kick-off.a5fe59c54f1d901506dc719253d111ff.svg";
export { ForwardRef as ReactComponent };